import { useSelector } from 'react-redux';

import { USER_TYPE } from 'constants/inquirys/userType';

export const useUserTypes = () => {
  const { type, association } = useSelector(state => state.logedUser);
  const isPM = type === USER_TYPE.InquiryRegistrationUser;
  const isAssociationRepresentative = type === USER_TYPE.AssociationRepresentative;
  return { isPM, isAssociationRepresentative, userType: type, association };
};
